import { render, staticRenderFns } from "./VersionTree.vue?vue&type=template&id=eeacef1e&"
import script from "./VersionTree.vue?vue&type=script&lang=js&"
export * from "./VersionTree.vue?vue&type=script&lang=js&"
import style0 from "./VersionTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports